import React from "react";
import { Route } from "react-router-dom";
import { AuthConsumer } from "../Authentication/AuthProvider";
import CustomSpinner from "./CustomSpinner";
// import roles from "../helpers/role";
// import AuthService from "../Authentication/AuthService";

export const PrivateRoute = ({ component, ...rest }) => {
  const renderFn = (Component) => (props) => (
    <AuthConsumer>
      {({ isAuthenticated, signinRedirect }) => {
        if (!!Component && isAuthenticated()) {
          return <Component {...props} />;
        } else {
          localStorage.clear();
          signinRedirect();
          return <CustomSpinner />;
        }
      }}
    </AuthConsumer>
  );
  return <Route {...rest} render={renderFn(component)} />;
};

export default PrivateRoute;